import React from "react";
import Modal from "material-ui/Modal";
import Paper from "material-ui/Paper";
import Button from "material-ui/Button";
import Grid from "material-ui/Grid";
import Typography from "material-ui/Typography";
import { withStyles } from "material-ui/styles";
import styles from "./styles";
import Icon from "material-ui/Icon";
import { toast } from "react-toastify";

import { ModalHeader, ModalContents, ModalFooter } from "../../modal";

import { storeLogo } from "../../../../common/storage";

const getOrientedImage = require("exif-orientation-image");

// const notify = msg => {
//   toast.error(msg, {
//     position: toast.POSITION.TOP_CENTER,
//     hideProgressBar: true
//   });
// };

class CustorgLogo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      errors: {},
      download: false,
      file: "",
      data: "",
      url: "",
      isOverSize: false,
      isInvalidType: false,
      isInvalidChar: false
    };
    this.handleClose = this.handleClose.bind(this);
    this.logoSelected = this.logoSelected.bind(this);
    this.logoSave = this.logoSave.bind(this);
  }

  handleClose() {
    this.props.cancel();
  }

  logoSelected(e) {
    e.preventDefault();
    let file = e.target.files[0];
    const restricted = [ '%', '#', '*', '/', '\\', '?', '<', '>', ':', '"', '|' ];
    if (file && file.name && file.name.split("").some(ch => restricted.indexOf(ch) != -1)) {
      this.setState({ isInvalidChar: true });
    }
    else if (file && file.type && !file.type.match("image/png") && !file.type.match("image/jpeg") && !file.type.match("image/bmp")) {
      this.setState({ isInvalidType: true });
    }
    else if (file.size > 1048576) {
      this.setState({ isOverSize: true });
      //notify("Upload failed. File size is larger than 1 mb.");
    } else {
      let reader = new FileReader();
      reader.onloadend = () => {
        getOrientedImage(file, (err, canvas) => {
          if (!err) {
            //code added so that canvas.toBlob() could work in Edge
            if (!HTMLCanvasElement.prototype.toBlob) {
              Object.defineProperty(HTMLCanvasElement.prototype, "toBlob", {
                value: function(callback, type, quality) {
                  var canvas = this;
                  setTimeout(function() {
                    var binStr = atob(
                        canvas.toDataURL(type, quality).split(",")[1]
                      ),
                      len = binStr.length,
                      arr = new Uint8Array(len);

                    for (var i = 0; i < len; i++) {
                      arr[i] = binStr.charCodeAt(i);
                    }

                    callback(new Blob([arr], { type: type || "image/png" }));
                  });
                }
              });
            }

            canvas.toBlob(
              data => {
                this.setState({
                  download: true,
                  file: file,
                  data: reader.result,
                  url: URL.createObjectURL(data)
                });
              },
              file.type,
              0.5
            );
          }
        });
      };
      reader.readAsDataURL(file);
    }
  }

  logoSave(e) {
    e.preventDefault();
    const { customerId, customer, mode } = this.props;
    const { data, file } = this.state;
    let type =
      this.props.container && this.props.container === "customers"
        ? "customer"
        : "org";
    storeLogo(type, customerId, file, data, customer, mode);
    this.props.logoStored(mode === "create");
  }

  render() {
    const { classes, customer, modal, container, translate } = this.props;

    let { url, isOverSize, isInvalidType, isInvalidChar } = this.state;
    let $imagePreview = null;
    if (url) {
      $imagePreview = <img alt="" src={url} className={classes.logoPreview} />;
    }
    if (customer === null) {
      return null;
    }
    return (
      <Modal open={modal} onClose={this.handleClose}>
        <div className={classes.root}>
          <Paper className={classes.modal}>
            <ModalHeader>
              <Typography type="headline" color="inherit">
                {translate("upload_logo_title")}
              </Typography>
              <Button className={classes.button} onClick={this.handleClose}>
                <Icon>clear</Icon>
              </Button>
            </ModalHeader>

            <ModalContents>
              <Grid container spacing={8}>
                <Grid item xs={6}>
                  <Typography type="subheading">
                    {container === "customers"
                      ? translate("upload_logo_customer")
                      : translate("upload_logo_org")}
                  </Typography>
                  <Button
                    raised
                    dense
                    color="secondary"
                    onClick={e => {
                      this.setState({ isOverSize: false, isInvalidType: false, isInvalidChar: false, url: "" });
                      this.upload.click();
                    }}
                    className={classes.logoSelect}
                  >
                    {translate("select_logo")}
                  </Button>
                  <p className={classes.logoHelp}>
                    {translate("logo_helper_text")}
                    <br />
                    {` ( %, #, *, \\, /, ?, <, >, :, ",| )`}
                  </p>
                  {isOverSize == true || isInvalidType == true || isInvalidChar == true ? (
                    <p className={classes.logoHelp}>
                      {(isOverSize) ? translate("logo_upload_size_validation") : isInvalidChar ? translate("logo_upload_char_validation") : translate("logo_upload_type_validation")}
                    </p>
                  ) : (
                    ""
                  )}
                </Grid>
                <Grid item xs={6}>
                  <div className={classes.logoPreviewHolder}>
                    <input
                      type="file"
                      ref={ref => (this.upload = ref)}
                      style={{ display: "none" }}
                      onChange={this.logoSelected}
                      accept="image/png, image/jpeg, image/bmp"
                      max-file-size="1024"
                    />
                    {$imagePreview}
                  </div>
                </Grid>
              </Grid>
            </ModalContents>

            <ModalFooter classes={classes}>
              {$imagePreview ? (
                <Button
                  raised
                  color="secondary"
                  className={classes.logoSelect}
                  onClick={this.logoSave}
                  type="submit"
                >
                  {translate("save_logo")}
                </Button>
              ) : null}
            </ModalFooter>
          </Paper>
        </div>
      </Modal>
    );
  }
}

export default withStyles(styles)(CustorgLogo);
